import { useTranslation } from 'react-i18next';
import { useUserRoles } from '@anytag/auth';
import { MarketplaceCampaignDetailType } from '@anytag/graphql';
import { useAllCountryOptions, useTranslateOptions } from '@anytag/shared-hooks';
import { Form } from '@anytag/shared-atoms';
import { SelectorField, TextSearchField } from '@anytag/shared-molecules';
import { useMarketplaceStatusOptions } from '../hooks';
import { MarketplaceCampaignsFilterFormKeys } from './schemaTypes';

export interface TemplateProps {
  onSubmit?: () => void;
}

export const Template = ({ onSubmit }: TemplateProps) => {
  const { t } = useTranslation();
  const { allCountryOptions } = useAllCountryOptions();
  const { isAdmin, isStaff } = useUserRoles();
  const { marketplaceStatusOptions } = useMarketplaceStatusOptions(true);

  const campaignDetailTypeOptions = useTranslateOptions([
    { label: 'Social media campaign', value: MarketplaceCampaignDetailType.NORMAL },
    { label: 'E-commerce marketplace type', value: MarketplaceCampaignDetailType.E_COMMERCE },
    { label: 'Referral code tracking', value: MarketplaceCampaignDetailType.REFERRAL_CODE },
    { label: 'URL tracking', value: MarketplaceCampaignDetailType.URL_TRACKING }
  ]);

  return (
    <Form.Fields>
      <TextSearchField<MarketplaceCampaignsFilterFormKeys>
        name="keyword"
        onSubmit={onSubmit}
        placeholder={t<string>('Search.MarketplaceFilter')}
      />
      <SelectorField<MarketplaceCampaignsFilterFormKeys>
        name="status"
        onSubmit={onSubmit}
        css={{ maxWidth: '158px' }}
        options={marketplaceStatusOptions}
        placeholder={t<string>('Selector.Status')}
      />
      <SelectorField<MarketplaceCampaignsFilterFormKeys>
        name="countryId"
        onSubmit={onSubmit}
        options={allCountryOptions}
        css={{ maxWidth: '158px' }}
        placeholder={t<string>('Selector.Countries')}
      />
      {isAdmin || isStaff ? (
        <SelectorField<MarketplaceCampaignsFilterFormKeys>
          onSubmit={onSubmit}
          className="max-w-45"
          name="campaignDetailType"
          options={campaignDetailTypeOptions}
          placeholder={t<string>('Selector.Campaign type')}
        />
      ) : null}
    </Form.Fields>
  );
};
